import React from 'react';

const ControlsPanel = ({
  searchQuery,
  setSearchQuery,
  activeCategory,
  setActiveCategory,
  sortBy,
  setSortBy,
  weightUnit,
  setWeightUnit
}) => {
  const categories = ['All', 'Strength', 'Cardio', 'Flexibility', 'Endurance'];

  return (
    <div className="controls-panel">
      {/* Search and Category Filter Section */}
      <div className="search-filter-box">
        {/* Search */}
        <div className="search-wrapper">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search exercises..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Category Tabs */}
        <div className="filter-tabs">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-tab ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Sorting & Unit Toggle Section */}
      <div className="sort-unit-box">
        {/* Sort Select */}
        <div className="select-wrapper">
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="highest-load">Highest Load</option>
            <option value="highest-reps">Highest Reps</option>
          </select>
        </div>

        {/* Display Units Toggle */}
        <button
          className="unit-toggle-btn"
          onClick={() => setWeightUnit(prev => (prev === 'lbs' ? 'kg' : 'lbs'))}
          title="Toggle display unit"
        >
          Unit: 
          <span className={weightUnit === 'lbs' ? 'active' : ''}>lbs</span>
          /
          <span className={weightUnit === 'kg' ? 'active' : ''}>kg</span>
        </button>
      </div>
    </div>
  );
};

export default ControlsPanel;
